<template>
  <v-container fluid class="pa-0 fill-height">
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-card class="pa-2">
          <v-row dense >
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.shipper')"
                  :value="pratica.shipper?.customerName"
                  icon="mdi-account-arrow-right"
                  :subValue="formatAddress(pratica.shipper)"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.consignee')"
                  :value="pratica.consignee?.customerName"
                  icon="mdi-account-check"
                  :subValue="formatAddress(pratica.consignee)"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.company')"
                  :value="company?.supplierName && company?.supplierId ? `${company.supplierName} - ${company.supplierId}` : null"
                  icon="mdi-account"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.loadingNode')"
                  :value="pratica.pol?.locode"
                  icon="mdi-map-marker-outline"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.vessel')"
                  :value="pratica.vesselName"
                  icon="mdi-ferry"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.dischargeNode')"
                  :value="pratica.pod?.locode"
                  icon="mdi-map-marker-outline"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.mbl')"
                  :value="pratica.billOfLading"
                  icon="mdi-file-document-outline"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.agent')"
                  :value="pratica.agent?.customerName"
                  icon="mdi-account-tie"
                  :subValue="formatAddress(pratica.agent)"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.freightTerms')"
                  :value="pratica.incoterms"
                  icon="mdi-file-document-outline"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.clientFm')"
                  :value="pratica.client?.customerName"
                  icon="mdi-account"
                  :subValue="formatAddress(pratica.client)"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.clientTo')"
                  :value="pratica.secondClient?.customerName"
                  icon="mdi-account"
                  :subValue="formatAddress(pratica.secondClient)"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.foreignCorrespondent')"
                  :value="pratica.foreignAgent?.supplierName"
                  icon="mdi-account-tie"
                  :subValue="formatAddress(pratica.foreignAgent)"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.shipperRef')"
                  :value="pratica.shipperRef"
                  icon="mdi-file-document-edit-outline"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.clientRef')"
                  :value="pratica.clientRef"
                  icon="mdi-file-document-edit-outline"
              />
            </v-col>
            <v-col cols="4"/>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.createDate')"
                  :value="createDate"
                  icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="4">
              <ReadonlyField
                  :label="$t('label.updateDate')"
                  :value="updateDate"
                  icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="4"/>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-3">
      <v-col class="pa-0">
        <v-card>
          <v-tabs
              v-model="tab"
              background-color="accent"
              height="2rem"
              grow
          >
            <v-tab>{{ $t('label.tracking') }}</v-tab>
            <v-tab>{{ $t('label.containers') }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card class="px-2 pt-2">
                <v-row dense>
                  <v-col class="d-inline-flex">
                    <v-col class="pa-0">
                      <ReadonlyField
                          :label="$t('label.departure')"
                          :value="seaTrackingDeparture"
                          :icon="'mdi-calendar'"
                      />
                    </v-col>
                  </v-col>
                  <v-col class="d-inline-flex">
                    <v-col class="pa-0">
                      <ReadonlyField
                          :label="$t('label.arrival')"
                          :value="seaTrackingArrival"
                          :icon="'mdi-calendar'"
                      />
                    </v-col>
                  </v-col>
                  <v-col cols="auto" class="ml-3 px-0">
                    <LinkPratica :praticaId="pratica.id" @send-link="loadNewMailTracking"/>
                    <EmailDialog
                        ref="emailDialog"
                        :msgTemplate="emailTemplate"
                        :emailAddresses="[]"
                        @email-sent="(resp) => handleDialog(!resp?.sent)"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mt-2 mb-0"/>
                <v-data-table
                    :headers="trackingHeadersMare"
                    :items="seaTerminalEvents"
                    :item-class="isDepartedFromPol"
                    :items-per-page="1000"
                    hide-default-footer
                    class="pa-0"
                    dense
                >
                  <template slot="no-data">
                    <v-icon color="warning" class="mr-1" size="20">
                      mdi-alert
                    </v-icon>
                    <span class="font-weight-medium warning--text">
                          {{ $t('label.noTrackingInfo') }}
                        </span>
                  </template>
                  <template v-slot:item.eventDateTime="{ item }">
                    {{ formatDateShort(item.eventDateTime) }}
                  </template>
                  <template v-slot:item.eventCode="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{
                            item.eventCode === 'EST' ? 'ESTIMATED'
                                : item.eventCode === 'ACT' ? 'ACTUAL'
                                    : item.eventCode === 'PLN' ? 'PLANNED' : ''
                          }}
                        </span>
                  </template>
                  <template v-slot:item.eventName="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventName }}
                        </span>
                  </template>
                  <template v-slot:item.eventType="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventType }}
                        </span>
                  </template>
                  <template v-slot:item.eventDescription="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventDescription }}
                        </span>
                  </template>
                  <template v-slot:item.transportMode="{ item }">
                    <div class="d-flex justify-center">
                      <v-icon v-if="item.transportMode === 'TRUCK'" color="primary">
                        mdi-truck
                      </v-icon>
                      <v-icon v-if="item.transportMode === 'VESSEL'" color="primary">
                        mdi-ferry
                      </v-icon>
                      <v-icon v-if="item.transportMode === 'RAIL'" color="primary">
                        mdi-train
                      </v-icon>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-2">
                <v-data-table
                    :headers="imballiHeaders"
                    :items="imballi"
                    :search="imballiSearch"
                    :items-per-page="1000"
                    hide-default-footer
                    class="pa-0"
                    dense
                >
                  <!-- imballiFiltered -->
                  <template v-slot:top>
                    <v-text-field
                        v-model="imballiSearch"
                        :label="$t('label.search')"
                        append-icon="mdi-magnify"
                        class="ma-0 pa-0 text-caption"
                        single-line
                        hide-details
                    />
                  </template>
                  <template slot="no-data">
                    <v-icon color="warning" class="mr-1" size="20">
                      mdi-alert
                    </v-icon>
                    <span class="font-weight-medium warning--text">
                          {{ $t('label.noTrackingInfo') }}
                        </span>
                  </template>
                  <template v-slot:item.transportOrderStatus="{ item }">
                    <span> {{ formatTrasportOrderStatus(item.transportOrderStatus) }} </span>
                  </template>
                  <template v-slot:item.grossWeight="{ item }">
                    {{ item.grossWeight }} {{ item.weightUOM }}
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Email from '@/mixins/Email'
import Tracking from '@/mixins/Tracking'
import {dateFilter} from '@/filters/dateFilter'
import ReadonlyField from '@/components/elements/ReadonlyField.vue'
import LinkPratica from '@/components/elements/pratica/LinkPratica.vue'
import EmailDialog from "../../mails/EmailDialog";

export default {
  name: 'ETPraticaTrasportoPrincipaleMare',
  props: ['pratica', 'imballi', 'company'],
  mixins: [Email, Tracking],
  components: {ReadonlyField, LinkPratica, EmailDialog},
  data() {
    return {
      tab: 0,
      trasportoPrincipaleFlags: [
        {text: this.$t('label.bookingRequested'), value: 'bookingRequested'},
        {text: this.$t('label.blRequested'), value: 'blRequested'},
        {text: this.$t('label.stuffing'), value: 'stuffingRequested'},
      ],
      imballiHeaders: [
        {text: this.$t('label.equipment'), value: 'equipmentReference'},
        {text: this.$t('label.quantity'), value: 'quantity'},
        {text: this.$t('label.grossWeight'), value: 'grossWeight'},
        {text: this.$t('label.item'), value: 'itemCode'},
        {text: this.$t('label.description'), value: 'itemDescription'},
        {text: this.$t('label.booking'), value: 'bookingNbr'},
      ],
      transitDays: null,
      imballiSearch: null,
    }
  },
  computed: {
    createDate() {
      return dateFilter.formatDateDay(this.pratica.creationDate)
    },
    updateDate() {
      return dateFilter.formatDateDay(this.pratica.updateDate)
    },
  },
  methods: {
    init() {
      this.getSeaTracking()
    },
    formatAddress(entity) {
      if (!entity || !entity.city) return null;
      return `${entity.city}${entity.countryId ? ', ' + entity.countryId : ''}`;
    }
  },
  created() {
    this.init()
  },

}
</script>

<style scoped>
::v-deep .readonly-field-label {
  font-size: 0.65rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #78909C !important; /* Muted blue-grey */
  margin-bottom: 2px;
}

::v-deep .readonly-field-value {
  font-size: 0.9rem !important;
  color: #263238 !important; /* High contrast dark */
  font-weight: 600;
}
</style>
